<template>
    <div class="traders-board-item">
        <h5 v-if="rarity" class="rarity-container position-absolute"><span class="rarity badge" :class="rarity">{{ rarity }}</span></h5>
        <div class="card" data-bs-toggle="tooltip" data-bs-placement="top" :title="title">
            <a href="#"
               :class="{ 'active': selected }"
               @click.prevent="toggleTrader">
                <picture>
                    <source :srcset="'https://pinandpop.s3.amazonaws.com/images/pinails/' + thumb + '.webp'" type="image/webp">
                    <source :srcset="'https://pinandpop.s3.amazonaws.com/images/pinails/' + thumb + '.jpg'" type="image/jpeg">
                    <img class="card-img-top border" :src="'https://pinandpop.s3.amazonaws.com/images/pinails/' + thumb + '.jpg'" :alt="title">
                </picture></a>
            <div v-if="isListed" class="traders-board-item-listing">LISTING</div>
        </div>
        <div class="pin-name"><span class="text-trader">{{ pin }}</span> {{ name }}</div>
        <div v-if="series" class="series-name">{{ series }}</div>
    </div>
</template>

<script>
export default {
    name: 'TradersBoardItem',
    props: {
        id: {
            type: Number,
            required: true
        },
        pin: {
            type: Number,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        series: {
            type: String,
            required: false
        },
        title: {
            type: String,
            required: true
        },
        selected: {
            type: Boolean,
            required: false,
            default: false
        },
        thumb: {
            type: String,
            required: true
        },
        rarity: {
            type: String,
            required: false
        },
        isListed: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        toggleTrader() {
            this.$emit('toggle', this.id);
        }
    }
}
</script>
